/* eslint-disable @typescript-eslint/ban-ts-comment */
import { addModal } from 'weblite-web-modal-viewer'
import { Support } from './support'

const COMPONENT_ID = 'support'

export const showSupportDialog = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: Support,
  },
}
